import React,  { Component } from 'react'
import dateTimeHelper from '../Helpers/datetimeHelper';
import listtableHelper from '../Helpers/listtableHelper';
import Voldemort from "./Voldemort";
import moneyHelper from '../Helpers/moneyHelper';

class ListTable extends Component {

    static defaultProps = {
        caption:"Default caption",
        data:[], 
        moneyFields:[],
        moneyFieldsSecondary:[],
        dateFields:[],
        dateOnlyFields:[],
        fieldsToShow:[],
        currency:[],
        currencySecondary: [],
        boolFields:[],
    }

    renderBlockHeader(i)
    {
        return(
            <div className="col-12 m-0 p-0 text-center" key={"divtable"+i}>
                {
                    this.props.fieldsToShow[i].label!==""
                    ? <h6>
                        {i>0 && <hr/>}
                        {this.props.fieldsToShow[i].label}
                    </h6>
                    : <p></p>
                }
            </div>
        );
    }

    renderDataField(datatext)
    {
        return(
            <span>
                {
                    datatext==="You-Know-Who"
                    ?<Voldemort/>
                    :datatext
                }
            </span>
        );
    }

    generateFieldContent(fieldname)
    {
        if(!(fieldname in this.props.data)) 
        {
            if(typeof fieldname!=="function")
            {
                return fieldname;
            }
            return fieldname(this.props.data);
        }

        if(this.props.dateFields.includes(fieldname)) return dateTimeHelper.toYYYYsMMsDDWithIndefinite(this.props.data[fieldname]);
        if(this.props.dateOnlyFields && Array.isArray(this.props.dateOnlyFields) && this.props.dateOnlyFields.includes(fieldname)) return dateTimeHelper.toYYYYsMMsDD(this.props.data[fieldname]);
        // if(this.props.dateFields.includes(fieldname)) return listtableHelper.formatDate(this.props.data[fieldname]);
        if(this.props.moneyFields.includes(fieldname)) return moneyHelper.toMoneyFormat(this.props.data[fieldname],this.props.currency);
        if(this.props.moneyFieldsSecondary.includes(fieldname)) return moneyHelper.toMoneyFormat(this.props.data[fieldname],this.props.currencySecondary);
        if(this.props.boolFields.includes(fieldname)) return listtableHelper.boolValueAsText(this.props.data[fieldname]);
        
        return this.renderDataField(this.props.data[fieldname]);
    }

    renderDataRow(i)
    {
        if(('condition' in this.props.fieldsToShow[i]) 
        && this.props.data[this.props.fieldsToShow[i].condition.field]!==this.props.fieldsToShow[i].condition.value)
        {
            return null;
        }

        return(
            <div className="col-4 m-0 p-0" key={"divtable"+i}>
                <div className="container">
                    <div className="row hover">
                        <div className="col">
                            {
                                this.props.fieldsToShow[i].label===""
                                ? listtableHelper.convertToWords(this.props.fieldsToShow[i].name)
                                : this.props.fieldsToShow[i].label
                            }
                        </div>
                        <div className="col text-center">
                            { this.generateFieldContent(this.props.fieldsToShow[i].name) }
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    
    renderMessageRow(i)
    {
        return(
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="m-0 p-1 font-weight-bold text-center" >
                            {this.props.fieldsToShow[i].label}
                        </div>                    
                    </div>
                </div>
            </div>

        );
    }


    renderRows() {
        var tables = [];
        for (var i = 0; i < this.props.fieldsToShow.length; i++) {
            tables.push(
                this.props.fieldsToShow[i].name==="-"
                ? this.renderBlockHeader(i)
                :   (   
                        this.props.fieldsToShow[i].name==="-message-"
                        ? this.renderMessageRow(i)
                        :this.renderDataRow(i)
                    )
            );
        }

        return tables;
    }

    render() {
        return (
            <div className="container">
                <div className="">
                    <h6>{this.props.caption}</h6>
                </div>
                <div className="row bg-white">
                    {this.renderRows()}
                </div>
            </div>
        );
    }

    

}




export default ListTable;
